import { Outlet } from 'react-router-dom';
import { OAuthCallbackCatcher } from '@/features/auth/OAuthCallbackCatcher';
import { AuthModal } from '@/features/auth/AuthModal';
import { LockerHost } from '@/features/profile/components/LockerHost';
import { Toaster } from '@/components/feedback/toast';
import { DefaultBackdrop } from '@/components/layout/DefaultBackdrop';
import { VoiceDock } from '@/features/communities/voice/VoiceDock';

/**
 * Top-of-tree layout. Mounts the OAuth code catcher + the global sign-in overlay
 * + the global Locker overlay + the toast host above every route, then renders
 * the matched route.
 */
export function RootLayout() {
  return (
    <>
      <DefaultBackdrop />
      <div className="relative z-10 min-h-screen">
        <OAuthCallbackCatcher />
        <Outlet />
        <AuthModal />
        <LockerHost />
        <VoiceDock />
        <Toaster />
      </div>
    </>
  );
}
